<template>
  <v-bottom-sheet
    v-model="chapterInfoBottomSheetIsOpen"
    scrollable
  >
    <v-card>
      <v-card-title class="mt-3">
        {{ currentContent.title }}
      </v-card-title>
      <v-card-text v-html="currentContent.description" />
    </v-card>
  </v-bottom-sheet>
</template>
<script>
export default {
  name: 'InfoAboutChapterBottomSheet',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    currentContent: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    chapterInfoBottomSheetIsOpen: {
      get() {
        return this.isOpen;
      },
      set(newValue) {
        this.$emit('close');
        return newValue;
      },
    },
  },
};
</script>
